<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<div class="content">
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<span style="float: left;">当前位置：</span>
								<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
								<el-breadcrumb-item :to="{ path: '/achievement' }">技术成果</el-breadcrumb-item>
							</el-breadcrumb>
						</el-col>
						<el-col :span="6">
							<el-input placeholder="输入关键字" v-model="title" @change="getAchievementsList"><el-button slot="append" icon="el-icon-search"></el-button></el-input>
						</el-col>
					</el-row>

					<el-row class="tabs" type="flex" justify="center">
						<el-col :span="6">
							<el-radio-group v-model="type" size="medium" @change="getAchievementsList">
								<el-radio-button label="1">技术需求</el-radio-button>
								<el-radio-button label="0" border>技术供应</el-radio-button>
							</el-radio-group>
						</el-col>
					</el-row>

					<el-row class="page">
						<el-col :xs="5" :sm="5" :md="5" :lg="4" :xl="4" class="type">
							<el-radio-group v-model="classify" @change="getAchievementsList">
								<el-radio label="" border>全部</el-radio>
								<el-radio border v-for="(item, index) in dictList" :key="index" :label="item.value">{{ item.label }}</el-radio>
							</el-radio-group>
						</el-col>
						<el-col :xs="19" :sm="19" :md="19" :lg="20" :xl="20" class="table">
							<div class="lists">
								<div class="list" v-for="(item, index) in achievementsList" :key="index" @click="goDetail(item)">
									<el-row class="name">
										<el-col :span="24">{{ item.title }}</el-col>
									</el-row>
									<el-row class="label">
										<el-col :span="16">
											<span>行业领域：{{ item.areaStr }}</span>
										</el-col>
										<el-col :span="8">
											<span>发布时间：{{ item.publishDate }}</span>
										</el-col>
									</el-row>
								</div>
							</div>
							<pagination v-show="pageTotal>0" :total="pageTotal" :page.sync="currentPage" :limit.sync="pageSize" @pagination="getAchievementsList" />
						</el-col>
					</el-row>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import Pagination from '@/components/Pagination';
import { dictList, achievementsList } from '@/api';
export default {
	name: 'index',
	components: {
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight,
		Pagination
	},
	data() {
		return {
			type: '0', //0 技术供应，1 技术需求
			title: '', //搜索框
			classify: '', //分类
			// 当前页数
			currentPage: 1,
			// 每页默认显示条数
			pageSize: 10,
			// 总条数
			pageTotal: 0,

			dictList: [],
			achievementsList: []
		};
	},
	mounted() {
		if (this.$route.query.keyWord) {
			this.title = this.$route.query.keyWord;
		}
		this.getDictList();
		this.getAchievementsList();
	},
	methods: {
		//获取字典列表
		getDictList() {
			let _this = this;
			dictList({
				type: 'msg_table_area'
			}).then(res => {
				_this.dictList = res.data;
			});
		},
		//获取技术列表
		getAchievementsList() {
			let _this = this;
			achievementsList({
				pageNo: _this.currentPage,
				pageSize: _this.pageSize,
				type: _this.type,
				title: _this.title,
				classify: _this.classify
			}).then(res => {
				_this.achievementsList = res.data.list;
				_this.pageTotal = res.data.count;
			});
		},
		//技术详情
		goDetail(item) {
			let routeUrl = this.$router.resolve({
				path: '/achievementDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: item.id
				}
			});
			window.open(routeUrl.href, '_blank');
		}
	}
};
</script>

<style lang="scss" scoped>
.page {
	min-height: 560px; /*若没有tabs56  height524 若有height468 */
}
.type .el-radio-group {
	display: flex;
	flex-direction: column;
}
.type .el-radio {
	margin-left: 0 !important;
	margin-right: 0 !important;
	margin-bottom: 10px;
}
.table {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 20px;
	padding-right: 20px;
	margin-bottom: 20px;
}
.lists {
	width: 100%;
}
.list {
	border-bottom: 1px solid #dddddd;
	cursor: pointer;
}
.name {
	font-size: 16px;
	padding-top: 10px;
}
.label {
	/* width: 98px; */
	height: 20px;
	color: rgba(153, 153, 153, 1);
	font-size: 14px;
	margin-top: 10px;
	margin-bottom: 10px;
}
.label span {
	margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/achievement.vue